export class ServiceError {
  message: string;
  name: string = 'ServiceError';

  constructor(message: string) {
    this.message = message;
  }
}